import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../store/slices/authSlice.js';
import DashboardLayout from '../components/dashboard/DashboardLayout.jsx';
import MetricsCards from '../components/dashboard/MetricsCards.jsx';
import ShipmentsTable from '../components/dashboard/ShipmentsTable.jsx';

const Dashboard = () => {
  const user = useSelector(selectUser);

  return (
    <DashboardLayout>
      <div className="space-y-4 sm:space-y-6 w-full max-w-full">
        {/* Welcome Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
          <div className="bg-primary-50 border border-primary-200 rounded-lg p-3 sm:p-4">
            <h2 className="text-base sm:text-lg font-semibold text-primary-800 mb-2">
              ¡Bienvenido al Dashboard, {user?.full_name}!
            </h2>
            <p className="text-sm sm:text-base text-primary-700">
              Sistema de Seguimiento de Envíos - ACTrack
            </p>
          </div>
        </div>

        {/* Metrics Cards */}
        <MetricsCards userRole={user?.role?.role_name} />

        {/* Información sobre funcionalidades */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="text-sm font-medium text-blue-900 mb-2">Funcionalidades disponibles:</h4>
          <ul className="text-xs text-blue-700 space-y-1">
            <li>• <strong>Ver:</strong> Muestra el historial completo de eventos del envío. {user?.role?.role_name === 'Cliente' || user?.role?.role_name === 'Notificado' ? 'Solo verás eventos aprobados.' : 'Podrás ver todos los eventos, aprobados y pendientes.'}</li>
            {(user?.role?.role_name === 'Administrador' || user?.role?.role_name === 'Transportista') && (
              <li>• <strong>Actualizar Estados:</strong> Utiliza el menú "Actualizar Estados" para agregar nuevos eventos de estado a los envíos.</li>
            )}
            <li>• <strong>Búsqueda:</strong> Utiliza la barra de búsqueda para filtrar envíos por manifest, reference, origen, destino o consignatario.</li>
            <li>• <strong>Tabs:</strong> Alterna entre "En Tránsito" (envíos activos) y "Completados" (envíos finalizados).</li>
          </ul>
        </div>

        {/* Shipments Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-4 sm:p-6 border-b border-gray-200">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900">
              Gestión de Envíos
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">
              Visualiza y gestiona los envíos según tu rol
            </p>
          </div>
          
          <div className="p-4 sm:p-6">
            <ShipmentsTable userRole={user?.role?.role_name} userId={user?.id} />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;